export const LANGUAGES = ["en", "it", "fr"] as const
export type Language = (typeof LANGUAGES)[number]

// The browser's own language if pdfview supports it, "en" otherwise.
export const DetectLang = (): Language => {
  const browser = navigator.language.slice(0, 2)
  return (LANGUAGES as Readonly<string[]>).includes(browser) ? (browser as Language) : "en"
}
